import { useState } from "react";
import { getImproveRankingCandidates, type QueueItem } from "../../../lib/corpusApi";
import { useAsyncPaginatedData } from "../../../hooks/useAsyncPaginatedData";
import { PAGE_SIZE_OPTIONS, type ListPagination } from "../../../lib/pagination";

export interface UseImproveRankingListResult {
  documents: QueueItem[];
  loading: boolean;
  error: string | null;
  pagination: ListPagination;
}

/** Fetches ingested documents sorted by rank_stability ascending (Improve Ranking, TAN-37). */
export function useImproveRankingList(): UseImproveRankingListResult {
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const {
    items: documents,
    loading,
    error,
    pagination,
  } = useAsyncPaginatedData(getImproveRankingCandidates, { pageSize: rowsPerPage });

  return {
    documents,
    loading,
    error,
    pagination: {
      ...pagination,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      onPageSizeChange: setRowsPerPage,
    },
  };
}
